import React from "react"
import { KontoInfo } from "../../app/apiSlice"
import Styles from "./KontoInfoView.module.css"

import Hjelpetekst from "./Hjelpetekst.jsx"
import { useAppSelector } from "../../app/hooks"
import { useCustomParams } from "../konto/useCustomParams"

type KontoInfoViewParam = {
  konto: KontoInfo
}

export default function KontoInfoView({ konto }: KontoInfoViewParam): React.ReactElement {
  const { kontonummer, navn, metaData } = konto
  const { orgForm, medMva } = useCustomParams()

  const { kontonumre } = useAppSelector((state) => state.konto)

  return (
    <div className={Styles.kontoInfo}>
      <h2>
        {kontonummer} - {navn}
      </h2>
      <Hjelpetekst hjelpetekst={metaData.hjelpetekst} orgForm={orgForm} medMva={medMva} kontonumre={kontonumre} />
    </div>
  )
}
